// extracted by mini-css-extract-plugin
module.exports = {"c8adam5":"c8adam5","loader":"loader","fullpage-layout":"fullpage-layout"};